export default "__VITE_PUBLIC_ASSET__109050f9__"